<template>
  <nav>
    <!-- Portal Educacional SSO temporariamente oculto.
    <a href="#" :class="{ disabled: openingPortalEducacional }" @click.prevent="openPortalEducacional">
      {{ openingPortalEducacional ? 'Abrindo...' : 'Portal Educacional' }}
    </a>
    -->
    <template v-for="item in fastMenu" :key="item">
      <a :href="item.router_link" @click="saveRotaFavorita(item)" v-if="item.router_link" :target="item.tipo_url">
        {{ item.name }}
      </a>
      <a :href="item.path" @click="saveRotaFavorita(item)" v-else-if="item.path" :target="item.tipo_url">
        {{ item.roleName }}
      </a>
      <a href="#" @click.prevent="goToRoute(item)" v-else-if="item.numeroDashboard">
        {{ item.name }}
      </a>
    </template>
  </nav>
</template>

<script>
import UserService from '@/services/user.service.js'

export default {
  data () {
    return {
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null,
      fastMenu: [],
      openingPortalEducacional: false
    }
  },
  mounted () {
    this.getMenuFavoritos()
  },
  methods: {
    getMenuFavoritos () {
      if (this.currentUser && this.currentUser.idPessoa) {
        UserService.getMenuFavoritos(this.currentUser.idPessoa).then(
          response => {
            console.log("getMenuFavoritos:", response.data)
            this.fastMenu = response.data
          },
          () => {

          }
        )
      }
    },
    openPortalEducacional () {
      if (this.openingPortalEducacional) return

      this.openingPortalEducacional = true
      UserService.getPortalEducacionalSso('P').then(
        response => {
          if (response.data?.url) {
            window.open(response.data.url, '_blank', 'noopener,noreferrer')
            return
          }

          window.toaster.emit('open', {style: "error", message: "Não foi possível abrir o Portal Educacional.", floater: true})
        },
        error => {
          const message = error?.response?.data?.message || "Não foi possível abrir o Portal Educacional."
          window.toaster.emit('open', {style: "error", message, floater: true})
        }
      ).finally(() => {
        this.openingPortalEducacional = false
      })
    },
    saveRotaFavorita ( route ) {
      const idPessoa = this.currentUser.idPessoa
      const data = {
        idPessoa: idPessoa,
        idRole: null,
        idPermission: route.id
      }

      UserService.saveRotaFavorita(data).then(
        response => {
          console.log("saveRotaFavorita:", response.data)
        }
      )
    },
    goToRoute(item) {
      if ( item.externo == 1 && item.numeroDashboard ) {
        // const query = this.getQueryStringParams(item.router_link)
        this.$router.push({name: 'Painel', params: { id: item.numeroDashboard }, query: {path: item.router_link} })
      }

      this.saveRotaFavorita(item)
    }
  }
}
</script>

<style lang="scss" scoped>
  nav {
    display: flex; align-items: center; align-content: center;
    gap: $mg_mid; margin-left: $hmg;

    a {
      // &:first-child {
      //   margin-left: $hmg_mid
      // }
      
      // margin-left: $mg_mid;

      &:hover {
        color: $color-primary
      }

      &.disabled {
        opacity: .65;
        pointer-events: none;
      }
    }

    @media screen and ( max-width: 1024px ) {
      flex-direction: column;
      gap: 0;
      margin-left: 0; margin-top: 2px;

      a {
        // margin-bottom: $hmg_mini;
        display: block;
        padding: $hmg_small $hmg_mid;
        width: 100%;
        border-bottom: $border-component;
      }
    }
  }
</style>
